var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEsgReason = function SvgEsgReason(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#EFE",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M21 28c6.085 0 11-5.387 11-12-6.062-.025-11 5.362-11 12M8 16c0 6.638 4.938 12 11 12 0-6.613-4.938-12-11-12M21 17c6.085 0 11-4.938 11-11-6.062-.023-11 4.915-11 11M8 6c0 6.085 4.938 11 11 11 0-6.062-4.938-11-11-11M21 38c6.085 0 11-4.938 11-11-6.062-.023-11 4.915-11 11M8 27c0 6.085 4.938 11 11 11 0-6.062-4.938-11-11-11"
  })));
};
export { SvgEsgReason as ReactComponent };
export default __webpack_public_path__ + "images/esg-reason.svg";